import React from 'react';
import { motion } from 'framer-motion';
export function CostSection() {
  const costs = [{
    sin: '120 hs/año planificando desde cero',
    costo: '10 min/semana. El resto es atender'
  }, {
    sin: '60% abandona antes de los 6 meses',
    costo: 'Sistema de progreso → retención +85%'
  }, {
    sin: '2-3 horas desde cero cada vez',
    costo: 'Plantillas listas → informe en 15 minutos'
  }, {
    sin: 'El de la OS que no cubre los costos',
    costo: 'Ingeniería de precios → 30-50% sobre el mercado'
  }, {
    sin: 'Trabajando para el lunes',
    costo: 'Tuyos. Completamente tuyos.'
  }];
  return <section className="py-10 px-4 pt-[15px] pb-[15px] flex-row items-center justify-center" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <div className="text-center mb-6" data-id="element-103">
          <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-104">
            🎙️ ¿Cuánto cuesta NO tenerlo?
          </h2>
          <p className="text-gray-400" data-id="element-105">
            O podés tener todo resuelto desde hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-106">
          {costs.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border p-4 rounded-xl" data-id="element-107">
              <div className="text-gray-400 text-xs mb-1" data-id="element-108">
                <span className="text-red-400 font-bold" data-id="element-109">Sin Ultrapack:</span>{' '}
                {item.sin}
              </div>
              <div className="text-brand font-bold text-sm" data-id="element-110">
                Con Ultrapack: {item.costo}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}